import { useQuery } from '@tanstack/react-query';

import { QueryFunction, useRequest } from '@frontend/api';

import type { SearchData } from '../common';
import { getUseSearchQuotesQueryKey, UseSearchQuotesQueryKey } from './keys';
import type { UseSearchQuotesParams } from './types';

export const useSearchQuotes: QueryFunction<
  SearchData,
  [body: UseSearchQuotesParams],
  UseSearchQuotesQueryKey
> = (body, { requestOptions, queryOptions } = {}) => {
  const request = useRequest(requestOptions);
  return useQuery({
    ...queryOptions,
    queryKey: getUseSearchQuotesQueryKey(body),
    queryFn: ({ signal }) =>
      request('/search/quotes', {
        init: {
          signal,
          method: 'POST',
          body: { ...body },
        },
      }),
  });
};
